import axiosV1 from "@/plugins/axios/configV1";

export default {
    /**
     * Fetch Admin user
     */
    get(params) {
        return axiosV1.get(`users/admins`, { params });
    },
    getAdmin(id) {
        return axiosV1.get(`users/admins/edit/${id}`);
    },
    getRoles() {
        return axiosV1.get("get-roles");
    },
    addAdmin(params) {
        return axiosV1.post("users/admins", { ...params });
    },
    editAdmin(id, params) {
        return axiosV1.post(`users/admins/update/${id}`, { ...params });
    },
    deleteAdmin(id) {
        return axiosV1.post(`users/admins/delete/${id}`);
    },
    deleteAdminAll(ids) {
        return axiosV1.post(`users/admins/bulk/delete`, ids);
    },
    recoverAdmin(id) {
        return axiosV1.post(`users/admins/revert/${id}`);
    },
    recoverAdminAll(ids) {
        return axiosV1.post(`users/admins/bulk/revert`, ids);
    },

    getViewAdmin(id, params) {
        return axiosV1.get(`users/admins/view/${id}`, { params });
    },

    exportExcel(params = {}) {
        return axiosV1.get(`users/admins/export`, { params });
    },
};
